module.exports = __webpack_public_path__ + "static/media/Ornate3_Before.b436ab63.jpg";